import React from "react";
import DataTable from "../../../components/common/DataTable";
import { TABLE_COLUMNS } from "../constants/logConstants";

/**
 * ScraperLogsTable component displays logs from scraper services
 *
 * This component renders scraper log streams in a filterable data table format.
 * It applies text filtering to all fields and handles empty log arrays gracefully.
 *
 * @param {Object} props - Component props
 * @param {Array} props.logs - The array of scraper log entries to display
 * @param {string} props.filterQuery - Text query to filter logs (case-insensitive)
 * @returns {JSX.Element} Rendered data table with formatted scraper logs
 */
function ScraperLogsTable({ logs, filterQuery }) {
  const displayFilteredLogs = () => {
    if (!logs) return [];
    const regex = new RegExp(filterQuery, "i");
    return logs.filter((obj) => regex.test(Object.values(obj)));
  };

  return <DataTable columns={TABLE_COLUMNS.logStreams} dataRows={displayFilteredLogs()} height={"70vh"} />;
}

export default ScraperLogsTable;
